import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { Container, Typography, Box } from '@mui/material';
import StepBlock from './StepBlock';
import NavBar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import { Banner, BannerText, BannerLogo } from '../../styles/Banner';
import {useTheme, useMediaQuery} from '@mui/material';
import { stepsData } from '../../constants/Ajuda/stepsData';
import { stepsOfertaData } from '../../constants/Ajuda/stepsOfertaData';
import { stepsProdutoData } from '../../constants/Ajuda/stepsProdutoData';

export default function ComoUtilizarCupom() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <>
            <NavBar/>
            <Banner>
                <BannerText>
                    <div>
                        <p>
                        <a href="https://www.meucupom.com/" target='_blank' rel="noreferrer">Home</a> &gt; Ajuda &gt; Como utilizar um cupom
                    </p>
                    </div>
                    <Typography variant='h2'  gutterBottom
                    >Como utilizar um cupom?</Typography>
                    <div>
                        <Link 
                        sx={{
                        color: 'white', 
                        marginRight: '10px', 
                        fontSize: { xs: '0.8rem', sm: '1rem', md: '1rem',
                        }}} 
                        component={RouterLink} to="/ajuda/perguntas-frequentes" underline="hover">
                                Perguntas frequentes?
                        </Link>
                        <Link 
                        sx={{
                        color: 'white', 
                        fontSize: { xs: '0.8rem', sm: '1rem', md: '1rem',
                    }}} 
                        component={RouterLink} to="/ajuda/como-utilizar-um-cupom" underline="hover">
                                Como utilizar um Cupom?
                        </Link>
                    </div>
                </BannerText>
                <BannerLogo>
                    <img 
                        src="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/logo-negative.png" 
                        alt="MeuCupom Logo" 
                    />
                </BannerLogo>
            </Banner>
            
            <div>
                <Typography  gutterBottom 
                sx={{
                    textAlign: 'center', 
                    marginTop: '3rem',
                    fontSize: { xs: '1.8rem', sm: '2rem', md: '2.8rem' }
                    }}>Como utilizar um cupom</Typography>
                <Box display="flex" justifyContent="center" my={4}>
                    <iframe
                        
                        width={isMobile ? '90%' : '760'}
                        height={isMobile ? '300' : '415'}
                        src="https://www.youtube.com/embed/YuXK2Q4Avf8?si=mPu62EC2A3iQAeCj"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </Box>
            </div>
            <Container maxWidth="lg" sx={{ py: 4 }}>
                {/* Cupom */}
                <StepBlock
                    imageTitleSrc="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/como-usar/titulo_cupom.png"
                    stepsData={stepsData}
                    finalMessage="O desconto será deduzido do valor final, assim que o código for inserido no campo correspondente. Finalize a compra."
                />
                {/* Oferta */}
                <StepBlock
                    imageTitleSrc="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/como-usar/titulo_oferta.png"
                    stepsData={stepsOfertaData}
                    finalMessage="O desconto está embutido no valor atual da oferta."
                />
                {/* Produto */}
                <StepBlock
                    imageTitleSrc="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/como-usar/titulo_produto.png"
                    stepsData={stepsProdutoData}
                    finalMessage="O desconto já está embutido no valor atual do produto."
                />
            </Container>
            <Footer/>
        </>
    );
}